import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './FunctionalSubGroupEntryV2.html?raw';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";
import ColorPicker from '../../../../moreCore/UI/ColorPicker/ColorPicker';
import MultiLangEdit from '../../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

class FunctionalSubGroupEntryV2 extends compose(_WidgetBaseSP) {
    templateString: any = template;

    isToDelete: boolean = false;

    fsg_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    fsg_Input_Description: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.FunctionalSubGroup_LoadData>>>;
    fsg_input_Coloration: MdsLax<InstanceType<typeof ColorPicker>>;
    fsg_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    functionalSubGroupMainContainer: HTMLElement;

    functionalSubGroupEditContainer: HTMLElement;

    formData: MainCatalogTypes.FunctionalSubGroup_SaveData = {
        ID: "",
        is_new_status: null,
        is_to_delete: null,
        code: "",
        description: null,
        order: null,
        coloration: null,
        __multilang: null
    };

    setEntry(isNew: boolean, entry?: MainCatalogTypes.FunctionalSubGroup_LoadData): void {
        this.fillFormData(entry, isNew);
    }

    fillFormData(data?: MainCatalogTypes.FunctionalSubGroup_LoadData, isNew?: boolean): void {

        if (data) {

            this.fsg_Input_Code.setValue(data.code, true);
            this.fsg_Input_Description.setValue({ entity: data, targetAttribute: "description" }, true);
            this.fsg_input_Coloration.setValue(data.coloration, true);
            this.fsg_Input_Order.setValue(data.order, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = isNew;
            this.formData.__multilang = data.__multilang;
        } else {

            this.fsg_Input_Code.setValue("", true);
            this.fsg_Input_Description.setEmptyValue("description");
            this.fsg_input_Coloration.setValue("", true);
            this.fsg_Input_Order.setValue(null, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
            this.formData.__multilang = {};
        }

        this.serializeFormData();
    }

    serializeFormData(): void {

        this.formData.code = this.fsg_Input_Code.getValue();
        this.formData.description = this.fsg_Input_Description.getValue().current;
        this.formData.__multilang["description"] = this.fsg_Input_Description.getValue();
        this.formData.order = this.fsg_Input_Order.getValue();
        this.formData.coloration = this.fsg_input_Coloration.getValue();

        this.formData.is_to_delete = this.isToDelete;

        if (this.formData.order == null) delete this.formData.order;

        console.debug("SUB GROUP SERIALIZED DATA", this.formData);

        this.emit("FunctionalSubGroup_SerializeData");
    }

    _onChangeFunctionalSubGroupInputData(): void {

        this.serializeFormData();
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.fsg_Input_Code.setMaxLength(10);
        this.fsg_Input_Description.setMaxLength(255);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(FunctionalSubGroupEntryV2.prototype, {
  fsg_Input_Code: () => (new Edit()),
  fsg_Input_Order: () => (new NumberInput()),
});
export default mdsWidget(FunctionalSubGroupEntryV2);
